var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoveToCategoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 15V8.8V6.6C17 6.04772 16.5523 5.6 16 5.6H9.05092C8.72241 5.6 8.41486 5.43865 8.22815 5.16837L7.71922 4.43164C7.53251 4.16135 7.22495 4 6.89645 4H4C3.44772 4 3 4.44772 3 5V8.8V15C3 15.5523 3.44772 16 4 16H16C16.5523 16 17 15.5523 17 15Z",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.007 10H5V11H12.007V12.5L15 10.5L12.007 8.5V10Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveToCategoryIcon);
export default __webpack_public_path__ + "static/media/move_to_category_icon.0e82ac0bb26bf9ac03bdf27af4f5f6f4.svg";
export { ForwardRef as ReactComponent };